import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { LanguageService } from '../../../core/services/language.service';
import { LocalService } from '../../../core/services/local.service';
import { MiscellaneousService } from '../../../core/services/miscellaneous.service';
import { LoaderService } from '../../../core/services/loader.service';
import { ZenSnackbarService, ZenSnackBarTypes } from 'src/app/shared/Theme/services/zen-snackbar.service';
import { ModuleName } from 'src/app/shared/enums/ModuleName';
import { TranslatePipe } from 'src/app/shared/pipes/translate.pipe';
import { LanguagePipe } from 'src/app/shared/pipes/language.pipe';
import { EngagementRespondent } from 'src/app/core/data-models/engagement-respondent';
import { RespondentService } from 'src/app/core/services/respondent.service';
import { LandingParamsResponse, SecureLandingService } from '@ex/module/core/services/secure-landing.service';
import { products } from '@ex/module/core/data-models/company-permission';
import { HappinessService } from '@ex/module/core/services/happiness.service';
import { ChildrenAnimation } from '@ex/module/shared/animations/allAnimations';
import { LandingForm } from '@ex/module/shared/questionnaire/shared-landing/shared-landing.component';
declare var $: any;
@Component({
  selector: 'app-happiness-landing-page',
  templateUrl: './happiness-landing-page.component.html',
  styleUrls: ['./happiness-landing-page.component.scss'],
  providers: [SecureLandingService],
  animations: [ChildrenAnimation]
})
export class HappinessLandingPageComponent implements OnInit {
  private subscriptions = new Subscription();
  referenceKey: string;
  secureLandingRequest$: Observable<LandingParamsResponse>;
  loader: boolean;
  valid: boolean;
  secureLandingFailed: boolean;


  constructor(private route: ActivatedRoute, private miscellanous: MiscellaneousService,
    private router: Router, public loaderService: LoaderService, private zenSnackBarService: ZenSnackbarService, private translationPipe: TranslatePipe,
    private respondentService: RespondentService, private secureLandingService: SecureLandingService, private happinessService: HappinessService) {

  }


  ngOnInit(): void {

    this.referenceKey = this.route.snapshot.paramMap.get('refKey');
    localStorage.setItem('LandingKey', this.referenceKey);

    this.secureLandingRequest$ = this.secureLandingService.specialLandingParams(this.referenceKey, products.Happiness);

  }

  onSubmit(event: { params: LandingParamsResponse, form: LandingForm, language: string }) {
    const [params, form, language] = [event.params, event.form, event.language];
    let request = {
      name: form.name, employeeID: form.id, email: form.email,
      referenceKey: this.referenceKey
    };
    this.loader = true;
    if (params?.isSecureLanding) {
      this.subscriptions.add(this.happinessService.getSecureRespondentLink(params.tenantKey, params.companyKey, params.surveyKey, request.email, request.employeeID).subscribe(data => {
        this.loader = false;
        if (data.response != 'SUCCESS')
          return this.secureLandingFailed = true;
        this.router.navigate([data?.Data?.link]);
      }))
    }
    else
      this.subscriptions.add(this.miscellanous.createHappinessRespondentFromLandingPage(request).subscribe((response: any) => {
        if (response.response == 'SUCCESS') {
          let respondent = response.data.respondent;
          let companyName = response.data.companyName;
          let surveyInfo = response.data.surveyInfo;
          let reses: EngagementRespondent[] = [];
          reses.push(respondent);
          let request = {
            SurveyType: "HAP",
            SurveyKey: surveyInfo.key,
            CompanyKey: respondent.companyKey,
            TenantKey: respondent.tenantKey,
            fromLanding: true,
            respondents: reses
          }
          console.log(respondent);
          this.respondentService.updateSurveyRespondent(request).subscribe((response: any) => {
            if (response.response == 'SUCCESS') {
              localStorage.setItem('LandingPageRef', respondent.referenceKey);
              this.router.navigate([
                '/happiness-questionnaire/' + respondent.referenceKey,
              ]);
            } else if (response.response == 'ERROR_EXISTS') {
              this.loader = false;
              this.zenSnackBarService.snackBar({ message: this.translationPipe.transform('txt_Linkhasal_237', language, ModuleName.Shared), type: ZenSnackBarTypes.Error });
            }
          });

        } else {
          if (response.message == 'INSUFFICIENT_FUNDS') {
            this.loader = false;
            this.zenSnackBarService.snackBar({ message: this.translationPipe.transform('txt_Insuffici_313', language, ModuleName.Shared), type: ZenSnackBarTypes.Error });
          }
        }
      }));
  }


  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
